import { postAxiosSingle } from 'pages/api/axios'
import { URL_LIST } from 'constants/url'
import { STATIC_URL } from 'constants/data'

const applyPromocode = async (
  event: any,
  PaymentData: any,
  promocode: any,
  setPromocode: any,
  newPrice: any
) => {
  event.preventDefault()
  event.target?.parentElement?.blur?.()

  try {
    const result = await postAxiosSingle(
      URL_LIST.PAYMENT_PROMOCODE,
      {},
      { code: promocode.code, courseId: PaymentData.materialId }
    )

    if (result.status === 200) {
      const { isRightCode, newPrice: finalPrice, percentage: finalPercentage, status } = result.data

      setPromocode((prevValue: any) => {
        const promoData = {
          ...prevValue,
          applied: true,
          discount: Boolean(isRightCode),
          newPrice: isRightCode ? finalPrice : newPrice,
          percentage: isRightCode ? finalPercentage : prevValue.percentage,
          status: status,
          code: isRightCode ? prevValue.code : '',
        }
        return promoData
      })
    } else {
      setPromocode((prevValue: any) => {
        const promoData = {
          ...prevValue,
          applied: true,
          discount: false,
          status: 'У курса нет промокодов',
          code: '',
        }
        return promoData
      })
    }
  } catch {
    console.log('Не удалось отправить промокод')
  }
}
const nameForOffer = ['Перейти к оплате', 'Оплатить', 'Подать заявку', 'Подать заявку']
const iconData = [
  {
    txt: 'Банковской картой',
    imgData: {
      height: 15,
      width: 104,
      src: `${STATIC_URL}/courses/icon_mir.svg`,
      alt: 'Банковской картой',
      unoptimized: true,
    },
  },
  {
    txt: 'Рассрочка Яндекс сплит',
    imgData: {
      height: 16,
      width: 59,
      src: `${STATIC_URL}/courses/icon_split.svg`,
      alt: 'Рассрочка Яндекс сплит',
      unoptimized: true,
    },
  },
  {
    txt: 'За счет работодателя',
    imgData: {
      height: 20,
      width: 20,
      src: `${STATIC_URL}/courses/icon_work.svg`,
      alt: 'За счет работодателя',
      unoptimized: true,
    },
  },
]

const letterImage = {
  width: 60,
  height: 60,
  src: `${STATIC_URL}/courses/succes.png`,
  alt: 'Успешно',
}

export interface IConsultPayload {
  email: string
  fullName: string
  phone: string
  path: string
  reason: string
  typePurchase?: string
}

export { applyPromocode, iconData, letterImage, nameForOffer }
